module.exports = __webpack_public_path__ + "static/media/RealLogo.60a84ca8.png";